'use client';

import CardGrid from '@/components/CardGrid';
import { useEffect, useState } from 'react';
import ListCard from '../EntryCard/EntryCard.List';
import { useNavbarState } from '../NavBar/useNavbarState';
import SkeletonCards from '../Skeleton/SkeletonCards';
import Divider from '../ui/Divider';
import EntryIndexNoResults from './EntryIndex.NoResults';
import { DEFAULT_LIMIT, DEFAULT_LIMIT_INCREASE, useEntryIndex } from './useEntryIndex';

/**
 * This component is responsible for rendering the entry index results
 * or no-results message
 */
const SearchIndexResults = () => {
  const { height, fallbackHeight } = useNavbarState();
  const initialLoaded = useEntryIndex((s) => s.initialLoaded);
  const items = useEntryIndex((s) => s.items);
  const hasResults = items.length > 0;
  const loading = useEntryIndex((s) => s.loading);
  const showLoading = loading || !initialLoaded;
  const [currentLimit, setCurrentLimit] = useState(DEFAULT_LIMIT);
  const scrollHeight = (height ?? fallbackHeight) + 2; // Adding 2px for better visibility

  useEffect(() => {
    if (items.length > currentLimit) {
      const firstNewItem = document.getElementById(items[currentLimit].id);
      firstNewItem?.scrollIntoView({
        block: 'start',
      });
      setCurrentLimit(currentLimit + DEFAULT_LIMIT_INCREASE);
    }
  }, [items]);

  return (
    <>
      {showLoading ? (
        <SkeletonCards
          amount={6}
          SkeletonItems={{ items: [{ variant: 'rounded', height: 200 }] }}
        />
      ) : hasResults ? (
        <>
          <Divider direction="horizontal" color="accent" size="md" />
          <CardGrid
            items={items}
            CardProps={{ style: { scrollMarginTop: scrollHeight } }}
            Component={ListCard}
            sm={12}
            rowGutter={false}
          />
        </>
      ) : (
        initialLoaded && <EntryIndexNoResults />
      )}
    </>
  );
};

export default SearchIndexResults;
